import { ImisFormWebhookResponse } from "../../models/imis.models";

export class FormWebhooksUtility {
    public static getWebhookResponseObject(): ImisFormWebhookResponse {
        return new ImisFormWebhookResponse();
    }

    public static addErrorResponse(formsWebhookResponse: ImisFormWebhookResponse, formsWebhookMessageLog: any[], errorMessageLog: any[]) {
        formsWebhookResponse.result = false;
        errorMessageLog.forEach(function (item) {
            formsWebhookMessageLog.push(item);
        });
    }

    public static getWebhookResponseMessage(formsWebhookMessageLog: any[], successMessage: string, messageSeparator: string): string {
        if (formsWebhookMessageLog.length > 0) {
            formsWebhookMessageLog = [successMessage].concat(formsWebhookMessageLog);
        }
        return formsWebhookMessageLog.join(messageSeparator);
    }
}